import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DatePicker from 'react-datepicker';

import '../../styles/Analytics.css';

import TeamsAnalyticsList from '../../containers/teams/TeamsAnalyticsList';

const styles = theme => ({
  datePickerContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  calendar: {
    zIndex: 999,
  },
  dateFilter: {
    height: '30px',
    padding: '10px 5px',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: '300',
    fontSize: '16px',
    border: '1px solid #aaa',
    borderRadius: '4px',
    margin: '5px 10px 5px 10px',
  },
  tableContainer: {
    maxWidth: 1000,
    '& table:first-child': {
      '& tr': {
        '& td:first-child, th:first-child': {
          backgroundColor: '#ffffff',
          position: 'sticky',
          left: 0,
          zIndex: 11,
        },
        '& th:first-child': {
          zIndex: 11,
        },
      },
    },
  },
  paper: {
    color: theme.palette.text.secondary,
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
  },
  cardTitle: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  favesSelectedValue: {
    color: '#FF3B00',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  leagueTop1Value: {
    color: '#FF8900',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  leagueTop2Value: {
    color: '#EDD200',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  leagueTop3Value: {
    color: '#00BC2B',
    fontSize: 40,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  cardSubValue: {
    color: '#000000',
    fontSize: 18,
    marginLeft: 15,
  },
  containerData: {
    justifyContent: 'space-around',
  },
});

class TeamsAnalyticsHome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldInput: false,
      valueInput: false,
      value: '',
      momentSuggestions: [],
      momentSelected: {},
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  renderSwitch(tab) {
    const { teamsAnalyticsList } = this.props;
    switch (tab) {
      case 0:
        return null;
      case 1:
        return <TeamsAnalyticsList teamsAnalyticsList={teamsAnalyticsList} />;
      default:
        return null;
    }
  }

  render() {
    const {
      classes,
      onChangeTab,
      selectedTab,
      favesSelected,
      leagueTop1,
      leagueTop2,
      leagueTop3,
    } = this.props;

    return (
      <React.Fragment>
        <Paper className={classes.paper} elevation={0}>
          <Grid container className={classes.containerData}>
            <Grid item xs={12}>
              <Typography className={classes.subtitle} variant="subtitle1" gutterBottom>
                Teams
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.datePickerContainer}>
                Start date:
                <DatePicker
                  popperClassName={classes.calendar}
                  className={classes.dateFilter}
                  placeholderText="Click to select a date"
                  selected={this.props.dateFrom}
                  onChange={date => this.props.setDateFrom(date)}
                  onBlur={() => this.props.getTeamAnalytics()}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  disabledKeyboardNavigation
                />
              </div>
              <div className={classes.datePickerContainer}>
                End date:
                <DatePicker
                  popperClassName={classes.calendar}
                  className={classes.dateFilter}
                  placeholderText="Click to select a date"
                  selected={this.props.dateTo}
                  onChange={date => this.props.setDateTo(date)}
                  onBlur={() => this.props.getTeamAnalytics()}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  disabledKeyboardNavigation
                />
              </div>
            </Grid>
            <Grid item>
              <div className={classes.favesSelectedValue}>{favesSelected}</div>
              <div className={classes.cardTitle}>Faves Selected</div>
            </Grid>
            <Grid item>
              {leagueTop1 && (
                <React.Fragment>
                  <div className={classes.leagueTop1Value}>
                    {leagueTop1.total}
                    <span className={classes.cardSubValue}>
                      {leagueTop1.percentage} %
                    </span>
                  </div>
                  <div className={classes.cardTitle}>{leagueTop1.name}</div>
                </React.Fragment>
              )}
            </Grid>
            <Grid item>
              {leagueTop2 && (
                <React.Fragment>
                  <div className={classes.leagueTop2Value}>
                    {leagueTop2.total}
                    <span className={classes.cardSubValue}>
                      {leagueTop2.percentage} %
                    </span>
                  </div>
                  <div className={classes.cardTitle}>{leagueTop2.name}</div>
                </React.Fragment>
              )}
            </Grid>
            <Grid item>
              {leagueTop3 && (
                <React.Fragment>
                  <div className={classes.leagueTop3Value}>
                    {leagueTop3.total}
                    <span className={classes.cardSubValue}>
                      {leagueTop3.percentage} %
                    </span>
                  </div>
                  <div className={classes.cardTitle}>{leagueTop3.name}</div>
                </React.Fragment>
              )}
            </Grid>
          </Grid>
        </Paper>
        <Paper className={classes.paper} elevation={0}>
          <Grid container>
            <Grid item xs={3}>
              <Tabs
                indicatorColor="primary"
                textColor="primary"
                value={selectedTab}
                onChange={onChangeTab}
                variant="fullWidth"
                scrollButtons="on"
              >
                <Tab label="STATUS" disabled={true} />
                <Tab label="FAVES" />
              </Tabs>
            </Grid>
            <Grid item xs={12}>
              {this.renderSwitch(selectedTab)}
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(TeamsAnalyticsHome);
